import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/services/auth.service';
import { ShareconfirmationdialogComponent } from '../shareconfirmationdialog/shareconfirmationdialog.component';
import { DoctypePipe } from 'src/app/core/services/doctype.pipe';

interface Person {
  id: string;
  name: string;
  email: string;
  avatar?: string;
  category: string;
  selected: boolean;
  profileUrl?: string; 
  isShared?: boolean; 
}

@Component({
    selector: 'app-sharedocumentdialog',
    templateUrl: './sharedocumentdialog.component.html',
    styleUrls: ['./sharedocumentdialog.component.css'],
    standalone: false
})
export class SharedocumentdialogComponent {
 selectedCategory = new FormControl('');
  people: Person[] = [];
  filteredPeople: Person[] = [];
  categories: string[] = ['All', 'Legal', 'Health', 'Personal', 'Identity'];
  selCon: any[] = [];
    doctypeMap: { [key: string]: string } = {
    driver_license: 'Driver\'s Licence',
    aadhar: 'AADHAR Card',
    pancard: 'PAN Card',
    passport: 'Passport',
    voterid: 'Voter ID',
    nic: 'National Identity Card',
    ssc: 'Social Security Card',
    tfn: 'Tax Filing Number',
    nino: 'National Insurance Number',
    nhsn: 'National Health Service Number',
     pio: 'PIO (Person of Indian Origin)',
    oci: 'OCI (Overseas Citizen of India)',
    sic: "Social Insurance Card",
    cpf: 'Cadastro de Pessoas Físicas (CPF)',
    birth_number: 'Birth Number',
    cvr_number: 'CVR Number',
    vat_number: 'VAT Registration Number',
    hetu: 'Personal Identification Number',
    hic: 'Health Insurance Card',
    nhi: 'National Health Index Number',
    tin: 'Tax Identification Number',
    pesel_number: 'PESEL Number',
    regon: 'REGON - Identification for Business',
    hun: 'Health User Number',
    ic_number: 'Civil Identification Number',
    nie: 'NIE (Foreigner Identification Number)',
    con: 'Co-Ordination Number',
    orn: 'Organisation Number',
  };

  
  constructor(
    private dialogRef: MatDialogRef<SharedocumentdialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {document: any, category: string},
    private sanitizer: DomSanitizer,
    public auth: AuthService,
    private toastr: ToastrService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    console.log("Data received in SharedocumentdialogComponent:", this.data);
    this.get_people(this.data.category);

    this.selectedCategory.valueChanges.subscribe(category => {
      this.filterPeople(category ?? "");
    });
  }

    get_people(category: any) {
    if (category == 'identity') {
      this.auth.get_identity_details(this.data.document.category, this.data.document.doctype, 'details').subscribe((res: any) => {
        if (res && res.data && res.data.details.sharedWith) {
          this.people = res.data.details.sharedWith.map((person: any) => {
            // Log the person object to debug what fields are available
            console.log("Person data from API:", person);
            
            // Try multiple possible field names for profile image
            const profileImage = person.profileUrl || person.avatar || person.profile_url || person.profilePic || person.profile_pic || person.image;
            
            return {
              id: person.relId,
              name: person.name,
              email: person.email,
              avatar: profileImage,
              profileUrl: person.profileUrl || person.profile_url,
              category: person.category || 'Identity',
              selected: person.isShared || false,
              isShared: person.isShared || false
            };
          });
          this.filteredPeople = [...this.people];
          console.log("Mapped People with avatars:", this.people);
        }
        
        if (res && res.data && res.data.details) {
          this.data.document.tags = res.data.details.tags || [];
          this.data.document.user_tags = res.data.details.user_tags || [];
          console.log("Document Tags (Identity):", this.data.document.tags);
          console.log("Document User Tags (Identity):", this.data.document.user_tags);
        }
      });
    } else {
      this.auth.get_personal_details(this.data.document.id, 'details').subscribe((res: any) => {
        console.log("Response from get_personal_details:", res);
        if (res && res.data && res.data.details.sharedWith) {
          this.people = res.data.details.sharedWith.map((person: any) => {
            // Log the person object to debug what fields are available
            console.log("Person data from API:", person);
            
            // Try multiple possible field names for profile image
            const profileImage = person.profileUrl || person.avatar || person.profile_url || person.profilePic || person.profile_pic || person.image;
            
            return {
              id: person.relId,
              name: person.name,
              email: person.email,
              avatar: profileImage,
              profileUrl: person.profileUrl || person.profile_url,
              category: person.category || 'Personal',
              selected: person.isShared || false,
              isShared: person.isShared || false
            };
          });
          this.filteredPeople = [...this.people];
          console.log("Mapped People with avatars:", this.people);
        }
        
        if (res && res.data && res.data.details) {
          this.data.document.tags = res.data.details.tags || [];
          this.data.document.user_tags = res.data.details.user_tags || [];
          console.log("Document Tags (Personal):", this.data.document.tags);
          console.log("Document User Tags (Personal):", this.data.document.user_tags);
        }
      });
    }
  }

  filterPeople(category: string): void {
    if (!category || category === 'All') {
      this.filteredPeople = [...this.people];
    } else {
      this.filteredPeople = this.people.filter(person => 
        person.category.toLowerCase() === category.toLowerCase()
      );
    }
  }

  getDoctypeName(doctype: string): string {
    // console.log('Getting doctype name for:', doctype);
    return this.doctypeMap[doctype] || doctype;
  }

  toggleSelection(person: Person): void {
    // If trying to unselect a person who already has the document shared
    if (person.selected && person.isShared) {
       person.selected = false;
      this.showUnshareConfirmation(person);
    } else {
      // For selecting or unselecting non-shared documents, toggle normally
      person.selected = !person.selected;
    }
  }

  getReadableDocType(doctype: string): string {
    const pipe = new DoctypePipe();  // create pipe instance
    return pipe.getDocLabelByType(doctype);  // use the pipe's transform logic
  }

  private showUnshareConfirmation(person: Person): void {

    if (this.data.category === 'identity')
      this.data.document.name = this.getReadableDocType(this.data.document.doctype);
    const confirmationDialogRef = this.dialog.open(ShareconfirmationdialogComponent, {
      data: {
        document: this.data.document,
        category: this.data.category,
        action: 'unshare',
        person: person,
        selectedPeople: [person] // For consistency with existing interface
      },
      width: '500px',
      disableClose: true
    });

    confirmationDialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        // User clicked "Stop Sharing" - proceed with unsharing
        this.unshareDocument(person);
      }
      else{
        person.selected = true;
      }
      // If "No" was clicked, do nothing (checkbox remains selected)
    });
  }

  private unshareDocument(person: Person): void {
    let docType = '';
    if (person.category === 'Identity') {
      docType = 'identity';
    } else if (person.category === 'Personal') {
      docType = 'personal';
    }

    // Create payload for unsharing (you might need to adjust this based on your API)
    let payload = {
      "documents": [
        {
          "docid": this.data.document.id,
          "doctype": docType
        }
      ]
    };

    // Call unshare API (assuming you have an unshare method)
    this.auth.unshare_realtionship_document(person.id, payload).subscribe({
      next: (res: any) => {
        console.log('Document unshared successfully', res);
        person.selected = false;
        person.isShared = false;
        this.toastr.success(`Document unshared with ${person.name}`, 'Success');
      },
      error: (error: any) => {
        console.error('Failed to unshare document', error);
        this.toastr.error(`Failed to unshare document with ${person.name}`, 'Error');
        // Keep the checkbox selected if the API call fails
      }
    });
  }

  getSelectedPeople(): Person[] {
    return this.people.filter(person => person.selected);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onShare(): void {
    const selectedPeople = this.getSelectedPeople();
    
    if (selectedPeople.length === 0) {
      this.toastr.warning('Please select at least one person to share the document with.', 'Warning');
      return;
    }

    // Filter out people who already have the document shared (only share with new people)
    const newShares = selectedPeople.filter(person => !person.isShared);
    
    if (newShares.length === 0) {
      this.toastr.info('All selected people already have access to this document.', 'Info');
      return;
    }

    if (this.data.category === 'identity')
      this.data.document.name = this.getReadableDocType(this.data.document.doctype);

    // Open confirmation dialog for new shares only
    const confirmationDialogRef = this.dialog.open(ShareconfirmationdialogComponent, {
      data: {
        document: this.data.document,
        selectedPeople: newShares,
        category: this.data.category
      },
      width: '500px',
      disableClose: true
    });

    confirmationDialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.shareDocumentWithSelectedPeople(newShares);
      }
    });
  }

  private shareDocumentWithSelectedPeople(selectedPeople: Person[]): void {
    let completedShares = 0;
    let failedShares = 0;
    const totalShares = selectedPeople.length;

    selectedPeople.forEach(person => {
      let docType = '';
      if (person.category === 'Identity') {
        docType = 'identity';
      } else if (person.category === 'Personal') {
        docType = 'personal';
      }

      let payload = {
        "documents": [
          {
            "docid": this.data.document.id,
            "doctype": docType
          }
        ]
      };

      this.auth.share_realtionship_document(person.id, payload).subscribe({
        next: (res: any) => {
          completedShares++;
          person.isShared = true; // Mark as shared
          if (completedShares + failedShares === totalShares) {
            this.handleShareCompletion(completedShares, failedShares, totalShares);
          }
        },
        error: (error: any) => {
          console.error('Failed to share with', person.name, error);
          failedShares++;
          if (completedShares + failedShares === totalShares) {
            this.handleShareCompletion(completedShares, failedShares, totalShares);
          }
        }
      });
    });
  }

  private handleShareCompletion(successful: number, failed: number, total: number): void {
    if (successful === total) {
      this.toastr.success('Document shared successfully', 'Success');
    } else if (successful > 0) {
      this.toastr.warning(`Document shared with ${successful} out of ${total} recipients`, 'Partial Success');
    } else {
      this.toastr.error('Failed to share document with any recipients', 'Error');
    }
    
    this.dialogRef.close(this.getSelectedPeople());
  }

  getInitial(name: string): string {
    return name.charAt(0).toUpperCase();
  }

  getAvatarColor(id: string): string {
    const colors = [
      '#0071C5'
    ];
    const index = parseInt(id, 10) % colors.length;
    return colors[index];
  }

  // Helper method to check if person has a valid profile image
  hasValidAvatar(person: Person): boolean {
    return !!(person.avatar && person.avatar.trim() !== '');
  }

  getDocumentPreviewUrl(): SafeUrl | string {
    if (this.data.document.previewUrl) {
      return this.data.document.previewUrl;
    }
    if (this.data.document.fileDataUrl) {
      return this.sanitizer.bypassSecurityTrustUrl(this.data.document.fileDataUrl);
    }
    return '';
  }

  formatDate(date: Date): string {
    if (!date) return 'N/A';
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }
}